import { PaginationResponse } from "models/pagination-response";
import { IPrestacaoContasPagedRequest } from "models/request/prestacao-contas-paged-request";
import { IPrestacaoContasPagedResponse } from "models/response/prestacao-contas-paged-response";
import { ITipoDocumentoPrestacaoContasResponse } from "models/response/tipo-documento-prestacao-contas-response";
import { IPrestacaoContasTotaisResponse } from "models/response/prestacao-contas-totais-response";

export type PrestacaoContasState = {
    prestacoesContas: PaginationResponse<IPrestacaoContasPagedResponse>;
    prestacaoContasPagedRequest: IPrestacaoContasPagedRequest;
    tipos: ITipoDocumentoPrestacaoContasResponse[];
    ultimaAtualizacao: string | null;
    totais: IPrestacaoContasTotaisResponse;
    loading: boolean;
    error: string | null;
};

export enum ACTION_TYPES {
    setPrestacoesContas = 'setPrestacoesContas',
    setPrestacaoContasPagedRequest = 'setPrestacaoContasPagedRequest',
    setTipos = 'setTipos',
    setUltimaAtualizacao = 'setUltimaAtualizacao',
    setTotais = 'setTotais',
    setLoading = 'setLoading',
    setError = 'setError',
}

export const PrestacaoContasReducer = (state: PrestacaoContasState, action: any): PrestacaoContasState => {
    const { type, payload } = action;
    switch (type) {
        case ACTION_TYPES.setPrestacaoContasPagedRequest:
            return { ...state, prestacaoContasPagedRequest: payload };
        case ACTION_TYPES.setPrestacoesContas:
            return { ...state, prestacoesContas: payload };
        case ACTION_TYPES.setTipos:
            return { ...state, tipos: payload };
        case ACTION_TYPES.setUltimaAtualizacao:
            return { ...state, ultimaAtualizacao: payload };
        case ACTION_TYPES.setTotais:
            return { ...state, totais: payload };
        case ACTION_TYPES.setLoading:
            return { ...state, loading: payload };
        case ACTION_TYPES.setError:
            return { ...state, error: payload };
        default:
            throw new Error(`Unhandled action type: ${type}`);
    }
}
